import React from "react";
import { env as environment } from "./actions/environment";

const Nocode = (props) => {
  window.location.replace(environment.frontendurl + window.location.search);

  return (
    <div className="App">
      <div className="loader_wrapper">
        <div className="dots-container">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
        <p className="wait-text">Please wait</p>
      </div>
    </div>
  );
};

export default Nocode;
